// Real Formulas theme — cart drawer + add-to-cart (AJAX Cart API)
(function () {
  'use strict';

  var CART_GET = '/cart.js';
  var CART_ADD = '/cart/add.js';
  var CART_CHANGE = '/cart/change.js';

  var cart = null;

  function money(cents) {
    var v = ((cents || 0) / 100).toFixed(2);
    return '$' + v;
  }

  function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function updateUI() {
    var n = cart ? cart.item_count : 0;
    qa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-visible', n > 0);
    });
    if (cart) {
      qa('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    }
  }

  function renderItems() {
    var body = document.querySelector('[data-cart-items]');
    if (!body) return;
    if (!cart || !cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">Your cart is empty</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variantHtml = item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
      return [
        '<div class="cart-item">',
        '<div class="cart-item__media"><img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" /></div>',
        '<div class="cart-item__info">',
        '<div class="cart-item__title">' + item.product_title + '</div>',
        variantHtml,
        '<div class="cart-item__price">' + money(item.final_line_price) + '</div>',
        '</div>',
        '<button class="cart-item__remove" data-remove data-line="' + line + '" aria-label="Remove">✕</button>',
        '<div class="cart-item__qty">',
        '<button data-qty-minus data-line="' + line + '" aria-label="Decrease quantity">−</button>',
        '<span>' + item.quantity + '</span>',
        '<button data-qty-plus data-line="' + line + '" aria-label="Increase quantity">+</button>',
        '</div>',
        '</div>'
      ].join('');
    }).join('');

    body.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () { changeQty(parseInt(b.dataset.line, 10), -1); });
    });
    body.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () { changeQty(parseInt(b.dataset.line, 10), 1); });
    });
    body.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { remove(parseInt(b.dataset.line, 10)); });
    });
  }

  function fetchCart() {
    return fetch(CART_GET).then(function (r) { return r.json(); });
  }

  function refresh(cb) {
    return fetchCart().then(function (c) {
      cart = c;
      updateUI();
      renderItems();
      if (cb) cb();
    }).catch(function () {
      cart = null;
      updateUI();
      renderItems();
    });
  }

  function changeQty(line, delta) {
    if (!cart || !cart.items) return;
    var item = cart.items[line - 1];
    if (!item) return;
    var newQty = item.quantity + delta;
    if (newQty <= 0) { return remove(line); }
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    }).then(function (r) { return r.json(); }).then(function () {
      return refresh();
    });
  }

  function remove(line) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function () {
      return refresh();
    });
  }

  function addToCart(variantId, quantity, sellingPlan) {
    var body = { id: variantId, quantity: quantity };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error('Cart add failed: ' + r.status); }
      return r.json();
    }).then(function () {
      return refresh();
    });
  }

  function openDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    renderItems();
  }
  function closeDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  // Wire open/close
  qa('[data-cart-toggle]').forEach(function (el) { el.addEventListener('click', openDrawer); });
  qa('[data-close-cart]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Add-to-cart forms (PDP + quick add)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.hasAttribute && form.hasAttribute('data-add-to-cart-form')) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]') || form.querySelector('[data-variant-id]');
      var variantId = idInput ? idInput.value : null;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var planInput = form.querySelector('[data-selling-plan-input]');
      var sellingPlan = (planInput && planInput.value) ? planInput.value : null;
      if (!variantId) return;
      addToCart(variantId, qty, sellingPlan).then(function () { openDrawer(); });
    }
  });

  // Initial cart load
  refresh();
})();

// Purchase options (one-time vs subscribe & save)
(function () {
  'use strict';
  var selector = document.querySelector('[data-purchase-selector]');
  if (!selector) return;
  var hidden = selector.querySelector('[data-selling-plan-input]');
  var planGroups = selector.querySelectorAll('[data-plans]');

  function currentPlan(group) {
    var pg = selector.querySelector('[data-plans][data-group="' + group + '"]');
    var checked = pg ? pg.querySelector('input[data-plan]:checked') : null;
    return checked ? checked.value : '';
  }

  function sync() {
    var chosen = selector.querySelector('input[data-purchase]:checked');
    var isSubscribe = chosen && chosen.getAttribute('data-purchase') === 'subscribe';
    selector.querySelectorAll('.pdp-purchase__opt').forEach(function (l) {
      l.classList.toggle('is-selected', l.querySelector('input') === chosen);
    });
    planGroups.forEach(function (pg) {
      pg.hidden = !(isSubscribe && pg.getAttribute('data-group') === chosen.getAttribute('data-group'));
    });
    hidden.value = isSubscribe ? currentPlan(chosen.getAttribute('data-group')) : '';
  }

  selector.querySelectorAll('input[data-purchase]').forEach(function (o) {
    o.addEventListener('change', sync);
  });
  selector.querySelectorAll('input[data-plan]').forEach(function (p) {
    p.addEventListener('change', function () {
      var chosen = selector.querySelector('input[data-purchase]:checked');
      if (chosen && chosen.getAttribute('data-purchase') === 'subscribe') hidden.value = p.value;
    });
  });
  sync();
})();

// Product category filter (arsenal grid + stack shortcuts)
(function () {
  'use strict';
  function activateFilter(cat) {
    var grid = document.getElementById('grid');
    if (!grid) return;
    var filters = document.querySelectorAll('#filters .filter');
    filters.forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.cat === cat);
    });
    grid.querySelectorAll('[data-type]').forEach(function (card) {
      var show = cat === 'all' || card.getAttribute('data-type') === cat;
      card.style.display = show ? '' : 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.filter');
    if (btn) { activateFilter(btn.dataset.cat); return; }
    var shortcut = e.target.closest && e.target.closest('[data-cat]');
    if (shortcut && !shortcut.classList.contains('filter')) {
      e.preventDefault();
      var cat = shortcut.dataset.cat;
      var products = document.getElementById('products');
      if (products) products.scrollIntoView({ behavior: 'smooth' });
      activateFilter(cat);
    }
  });
})();

// Product detail page: variant selector, qty, sticky bar, FAQ
(function () {
  'use strict';
  var form = document.querySelector('[data-add-to-cart-form]');
  var picker = document.querySelector('[data-variant-picker]');
  var jsonEl = document.querySelector('[data-variants]');

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  // Variant selection
  if (picker && jsonEl && form) {
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
    var priceEl = document.querySelector('[data-price]');
    var priceStickyEl = document.querySelector('[data-price-sticky]');
    var idInput = form.querySelector('[data-variant-id]');
    var imgEl = document.getElementById('PdpMainImage');
    var selected = {};
    var def = variants[0];
    for (var i = 1; i <= 3; i++) {
      if (def && def['option' + i]) selected[i - 1] = def['option' + i];
    }

    function findVariant() {
      return variants.find(function (v) {
        for (var k in selected) {
          if (v['option' + (parseInt(k, 10) + 1)] !== selected[k]) return false;
        }
        return true;
      });
    }
    function apply() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (priceStickyEl) priceStickyEl.textContent = fmt(v.price);
      if (imgEl && v.featured_image) imgEl.src = v.featured_image;
    }
    picker.querySelectorAll('.pdp-flavor-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optIdx = parseInt(pill.dataset.option, 10);
        selected[optIdx] = pill.dataset.value;
        picker.querySelectorAll('[data-option="' + optIdx + '"]').forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
          p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
        });
        apply();
      });
    });
    apply();
  }

  // Quantity stepper
  var qtyInput = document.querySelector('[data-qty-input]');
  if (qtyInput) {
    var minus = document.querySelector('[data-pdp-qty-minus]');
    var plus = document.querySelector('[data-pdp-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  // Add-to-cart jump buttons trigger the form submit (drawer opens via cart logic)
  document.querySelectorAll('[data-add-to-cart-jump]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submit = document.querySelector('[data-add-to-cart]');
      if (submit) submit.click();
    });
  });

  // Sticky buy bar reveal
  var stickyBar = document.getElementById('stickyBar');
  var buy = document.getElementById('buy');
  if (stickyBar && buy) {
    function showBar() {
      if (buy.getBoundingClientRect().bottom < 0) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }
    window.addEventListener('scroll', showBar, { passive: true });
    showBar();
  }

  // FAQ single-open behavior
  document.querySelectorAll('.pdp-faq__item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        document.querySelectorAll('.pdp-faq__item').forEach(function (o) {
          if (o !== item) o.open = false;
        });
      }
    });
  });
})();

// Journal post expand/collapse
(function () {
  'use strict';
  document.querySelectorAll('.jr-post').forEach(function (card) {
    var toggle = card.querySelector('.jr-post__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      var label = toggle.querySelector('.jr-post__toggle-label');
      if (label) label.textContent = open ? 'Close' : 'Read';
      toggle.setAttribute('aria-expanded', String(open));
    });
  });
})();